import PubSub = require('pubsub');

export { PubSub };

export module Subscriptions {
    export module App {
        export var All = "App";
        export var RedirectPage = "App.RedirectPage";
        export var OpenPopup = "App.OpenPopup";
        export var OpenPopupFullScreen = "App.OpenPopupFullScreen";
        export var OpenPopupPreventCaching = "App.OpenPopup.PreventCaching";
        export var Navigate = "App.Navigate";
        export var BackOrDefault = "App.BackOrDefault";
        export var SwitchFacility = "App.SwitchFacility";
        export var ConfirmLogout = "App.ConfirmLogout";
        export var UpdatePageViewModel = "App.UpdatePageViewModel";
        export var UpdatePageViewModelParams = "App.UpdatePageViewModelParams";
        export var ReloadMenu = "App.ReloadMenu";
        export var GoHome = "App.GoHome";
        export var RefreshParent = "App.RefreshParent";
        export var RefreshWidget = "App.RefreshWidget";
        export var MainContentVisible = "App.MainContentVisible";
        export var SchedulerRefetchEvents = "App.SchedulerRefetchEvents";
        export var DynamicAddItem = "App.DynamicAddItem";
        export var IFrameClicked = "App.IFrameClicked";
        export var AutoCorrect = "App.AutoCorrect";
        export var EmergencyAccessVisible = "App.EmergencyAccess";
        export var ExecuteJs = "App.ExecuteJs";
        export var SettingsSubmitted = "App.SettingsSubmitted";
        export var UpdateMenuName = "App.UpdateMenuName";
        export var SignedDocModifyWarningAfter = "App.SignedDocModifyWarningAfter";
        export var ReloadPatientPanel = "App.ReloadPatientPanel";
        export var ReloadProgressNotePanel = "App.ReloadProgressNotePanel";
        export var DocumentEditorSubmit = "App.DocumentEditorSubmit";
        export var RefreshPatientPanel = "App.RefreshPatientPanel";
        export var ReloadWaitlistPatientView = "App.ReloadWaitlistPatientView";
        export var RequestPatientFeedback = "App.RequestPatientFeedback";
    }

    export const PracticeEhrRcm = {
        Open: 'PracticeEhrRcm.Open'
    }

    export const NHMessaging = {
        Open: 'NHMessaging.Open'
    }

    export module Modals {
        export var ConfirmYesNo = "Modals.ConfirmYesNo";
        export var Warning = "Modals.Warning";
        export var CheckIn = "Modals.CheckIn";
        export var AncillaryServices = "Modals.AncillaryServices";
        export var AuthorizedRepresentative = "Modals.AuthorizedRepresentative";
        export var DirectMessagingRegistrtaion = "Modals.DirectMessagingRegistration";
        export var LoadDocumentationViewConfiguration = "Modals.LoadDocumentationViewConfiguration";
        export var PatientSearch = "Modals.PatientSearch";
        export var PatientSearchSelected = "Modals.PatientSearchSelected";
        export var CompanyPatient = "Modals.CompanyPatient";
        export var AssessmentTiming = "Modals.AssessmentTiming";
        export var Insurance = "Modals.Insurance";
        export var AddNewAction = "Modals.AddNewAction";
        export var ProtocolDetail = "Modals.ProtocolDetail";
        export var AddWorkersCompensationAuthorizationSchedule = "Modals.AddWorkersCompensationAuthorizationSchedule";
        export var WorkersCompensationAuthorizationScheduleSelected = "Modals.WorkersCompensationAuthorizationScheduleSelected";
        export var SelectInsuranceAuthorizations = "Modals.SelectInsuranceAuthorizations";
        export var ImplantableDevice = "Modals.ImplantableDevice";
        export var Medications = "Modals.Medications";
        export var Epcs = "Modals.Epcs";
        export var EpcsRenew = "Modals.EpcsRenew";
        export var CreatePatientStatementBatch = "Modals.CreatePatientStatementBatch";
        export var SignMedications = "Modals.SignMedications";
    }

    export module Search {
        export var All = "Search";
        export var Toggle = "Search.Toggle";
        export var Close = "Search.Close";
        export var SwitchTabs = "Search.SwitchTabs";
        export var ClearSearch = "Search.ClearSearch";
        export var DefaultSearchChange = "Search.DefaultSearchChange";
    }

    export module Workflow {
        export var All = "Workflow";
        export var SubmitClicked = "Workflow.SubmitClicked";
        export var SubmitAndLockClicked = "Workflow.SubmitAndLockClicked";
        export var SubmissionComplete = "Workflow.SubmissionComplete";
        export var IframeSubmissionRequest = "Workflow.SubmissionRequest";
        export var ReloadWorkflow = "Workflow.ReloadWorkflow";
        export var SyncWorkflowState = "Workflow.SyncWorkflowState";
        export var SyncIframeDocument = "Workflow.SyncIframeDocument";
        export var DeleteClicked = "Workflow.DeleteClicked";
        export var DocumentDeleted = "Workflow.DocumentDeleted";
        export var DiscardClicked = "Workflow.DiscardClicked";
        export var ShowSubmitAndLock = "Workflow.ShowSubmitAndLock";
        export var ShowDelete = "Workflow.ShowDelete";
        export var SpecialEditorDocType = "Workflow.SpecialEditorDocType";
        export var ShowWoundButtons = "Workflow.ShowWoundButtons";
        export var VisitAction = "Workflow.VisitAction";
        export var ReloadActivityFeed = "Workflow.ReloadActivityFeed";
        export var DocumentLocked = "Workflow.DocumentLocked";
        export var UserCanModifyLockedDocument = "Workflow.UserCanModifyLockedDocument";
        export var CancelComplete = "Workflow.CancelComplete";
        export var ReloadIFrame = "Workflow.ReloadIFrame";
        export var UnloadIFrame = "Workflow.UnloadIFrame";
        export var ChangeVisit = "Workflow.ChangeVisit";
        export var VisitInfoSubmitted = "Workflow.VisitInfoSubmitted";
        export var NavigateToWorkflowStep = "Workflow.NavigateToWorkflowStep";
        export var DisableButtonsToken = "Workflow.DisableButtonsToken";
        export var EnableButtonsToken = "Workflow.EnableButtonsToken";
        export var Alerts = "Workflow.Alerts";
        export var ResizeNodes = "Workflow.ResizeNodes";
        export var ReloadVisitInformation = "Workflow.ReloadVisitInformation";
        export var VirtualKeyboardOpen = "Workflow.VirtualKeyboardOpen";
        export var VirtualKeyboardClose = "Workflow.VirtualKeyboardClose";
        export var TaskDrawerState = "Workflow.TaskDrawerState";
        export var DetailsModalShow = "Workflow.DetailsModalShow";
        export var DetailsModalHide = "Workflow.DetailsModalHide";
        export var DualDocumenterOpen = "Workflow.DualDocumenterOpen";
        export var DualDocumenterClose = "Workflow.DualDocumenterClose";
        export var ReloadWorkflowVisitInfo = "Workflow.ReloadWorkflowVisitInfo";
        export var WoundReconciliationAvailable = "Workflow.WoundReconciliationAvailable";
        export var DebridementReconciliationAvailable = "Workflow.DebridementReconciliationAvailable";
    }

    export module Billing {
        export var ReloadBatch = "Billing.ReloadBatch";
        export var AccountChange = "Billing.AccountChange";
        export var DebtorChange = "Billing.DebtorChange";
        export module ClaimsList {
            export var Reload = "Billing.ClaimsList.Reload";
            export var ReloadOnReturn = "Billing.ClaimsList.ReloadOnReturn";
            export var ApplyFilter = "Billing.ClaimsList.ApplyFilter";
        }

        export module PatientTransactionHistory {
            export var Open = "Billing.PatientTransactionHistory.Open";
        }

        export var PrintClaims = "Billing.PrintClaims";
        export var ClaimFacilitySelected = "Billing.ClaimFacilitySelected";
        export var UseFacilityBill = "Billing.UseFacilityBilling";
        export var Icd10RequiredChange = "Billing.Icd10RequiredChange";
        export var FilterCollapsed = "Billing.FilterCollapsed";
    }

    export module Overlay {
        export var All = "Overlay";
        export var Search = "Overlay.Search";
        export var App = "Overlay.App";
        export var Targetted = "Overlay.Targetted";
    }

    export module Iframe {
        export var All = "IFrame";
        export var Resized = "IFrame.Resized";
        export var Reload = "IFrame.Reload";
        export var SubmissionStopped = "IFrame.SubmissionStopped";
        export var ExecuteJs = "IFrame.ExecuteJs";
        export var ToggleIFrameButtons = "IFrame.ToggleIFrameButtons";
    }

    export module Patient {
        export var All = "Patient";
        export var Delete = "Patient.Delete";
        export var PatientLookup = "Patient.PatientLookup";
        export var PatientSelected = "Patient.PatientSelected";
        export var PatientLookup = "Patient.PatientLookup";
        export var PatientSelected = "Patient.PatientSelected";
        export var PatientAddressUpdated = "Patient.AddressUpdated";
        export var PatientAddressValidated = "Patient.AddressValidated";
        export var PatientZipCodeEntered = "Patient.ZipCodeEntered";
        export var PatientCountyEntered = "Patient.PatientCountyEntered";
        export var PatientPharmacySelected = "Patient.PharmacySelected";
    }

    export module Scheduler {
        export var All = "Scheduler";
        export var UpdateSelectedEvent = "Scheduler.UpdateSelectedEvent";
        export var UpdateCopiedEvent = "Scheduler.UpdateCopiedEvent";
    }

    export module AlphaPagination {
        export var Clear = "AlphaPagination.Reset";
        export var Update = "AlphaPagination.Update";
    }

    export module Accounting {
        export var PatientChanged = "Accounting.PatientChanged";
        export var PatientInfo = "Accounting.PatientInfo";
        export var TransactionModal = "Accounting.TransactionModal";
        export var AddTransactionDetail = "Accounting.AddTransactionDetail";
        export var CombineBatchesModal = "Accounting.CombineBatchesModal";
        export var BatchesReload = "Accounting.BatchesReload";
        export var UnappliedPayments = "Account.UnappliedPayments";
    }

    export module ERA {
        export var ModifyERATransaction = "Subscriptions.ERA.ModifyERATransaction";
        export var UpdatedERATransaction = "Subscriptions.ERA.UpdatedERATransaction";
    }

    export module Accounting {
        export var PatientChanged = "Accounting.PatientChanged";
        export var PatientInfo = "Accounting.PatientInfo";
        export var TransactionModal = "Accounting.TransactionModal";
        export var AddTransactionDetail = "Accounting.AddTransactionDetail";
        export var CombineBatchesModal = "Accounting.CombineBatchesModal";
        export var BatchesReload = "Accounting.BatchesReload";
    }

    export module PatientStatementBatch {
        export var PatientStatementBatchModal = "PatientStatementBatch.CreatePatientStatementBatchModal";
        export var AddressUpdateConfirmation = "PatientStatementBatch.AddressUpdateConfirmationModal"
        export var PatientStatementBatchModalOpen = "PatientStatementBatch.PatientStatementBatchModalOpen";
        export var AddressUpdatesConfirmationReview = "PatientStatementBatch.AddressUpdateConfirmationReview";
    }

    export module BatchPrint {
        export var BatchPrintPdfGenerationCompleted = "BatchPrint.BatchPrintPdfGenerationCompleted";
    }

    export module ERA {
        export var ModifyERATransaction = "Subscriptions.ERA.ModifyERATransaction";
    }

    export module BillingReports {
        export var PrintBillingReport = "BillingReports.PrintBillingReport";
        export var ExportBillingReport = "BillingReports.ExportBillingReport";

    }

    export module User {
        export var UnreadMessageCount = "User.UnreadMessageCount";
        export var PatientMessagingAlertCount = "User.PatientMessagingAlertCount";
    }

    export module Whiteboard {
        export var PatientAdded = "Whiteboard.PatientAdded";
        export var VisitCancel = "Whiteboard.VisitCancel";
        export var VisitCancelled = "Whiteboard.VisitCancelled";
        export var broadcastWhiteBoardTileMovement = "Whiteboard.broadcastWhiteBoardTileMovement";
        export var broadcastWhiteBoardVisitStatusUpdate = "Whiteboard.broadcastWhiteBoardVisitStatusUpdate";
        export var broadcastWhiteBoardAddVisit = "Whiteboard.broadcastWhiteBoardAddVisit";
    }

    export module AncillaryServices {
        export var AncillaryServiceUpdated = "AncillaryServices.AncillaryServiceUpdated";
    }

    export module PatientDemographics {
        export var ComponentOfCareAddressSelected = "PatientDemographics.ComponentOfCareAddressSelected";
        export var PatientDOB = "PatientDemographics.PatientDOB";
    }

    export module ChatWidget {
        export var Hide = "ChatWidget.Hide";
        export var Show = "ChatWidget.Show";
        export var Maximize = "ChatWidget.Maximize";
        export var StateChanged = "ChatWidget.StateChanged";
    }
}
